import SearchForm from './SearchFormGenerator';

export default SearchForm;
